import { SbBlokData, storyblokEditable } from "@storyblok/react"
import { Anchor } from "../../app/components/anchor"
import Markdown from "../../components/content/Markdown"

export interface ISupport extends SbBlokData {
  markdown: string
  bgColor: "white" | "gray12"
}

export default function Support({ blok }: { blok: ISupport }) {
  return (
    <section
      className={`mx-auto px-4 py-20 sm:py-32 max-w-[75ch] text-center text-xl`}
      {...storyblokEditable(blok)}
    >
      {blok?.markdown ? (
        <Markdown className="hover:no-underline">{blok?.markdown}</Markdown>
      ) : (
        <>
          <h3 className="text-4xl text-blue7 font-montserrat pb-8">
            We’re here for you the entire ride
          </h3>
          <p>
            For additional information, please consult the{" "}
            <Anchor href="/faq">FAQ</Anchor> or browse through our{" "}
            <Anchor href="https://help.citizenshipper.com/hc/en-us">
              Help Center articles
            </Anchor>
            .
          </p>
          <p>
            We take pride in our unmatched Customer Support Team! You can always{" "}
            <Anchor
              href="https://help.citizenshipper.com/hc/en-us/requests/new"
              newTab
            >
              contact us here
            </Anchor>{" "}
            for one-on-one assistance.
          </p>
        </>
      )}
    </section>
  )
}
